export const CONTACT = {
  brand: "MAXREVIX",
  city: "Saint-Pierre-en-Faucigny",
  address: "74800 Saint-Pierre-en-Faucigny, Haute-Savoie (74)",
  phoneDisplay: "06 28 64 82 16",
  phoneHref: "tel:+33628648216",
  email: "contact@maxrevix.fr",
  hours: "Du lundi au vendredi · 09h00 – 19h00",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Saint-Pierre-en-Faucigny+74800",
};

export const IMG = {
  hero: "https://images.unsplash.com/photo-1550041473-d296a3a8a18a?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=1200",
  tools: "https://images.unsplash.com/photo-1639776738932-956082f0b704?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=1200",
  broken: "https://images.unsplash.com/photo-1746006084492-24a8fd02710a?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=1200",
  motherboard: "https://images.unsplash.com/photo-1611396000732-f8c9a933424f?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=1200",
  components: "https://images.unsplash.com/photo-1588515603140-81bd9f7d1db0?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=1200",
  soldering: "https://images.unsplash.com/photo-1560846389-8c7e1d88eca8?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=1200",
  restored: "https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?crop=entropy&cs=srgb&fm=jpg&q=85&auto=format&fit=crop&w=1200",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Tarifs", href: "#tarifs" },
  { label: "Rachat", href: "#rachat" },
  { label: "Boutique", href: "#boutique" },
  { label: "Reconditionné", href: "#reconditionne" },
  { label: "Avis", href: "#avis" },
  { label: "FAQ", href: "#faq" },
];

export const MARQUEE_ITEMS = [
  "Réparation express 30 min",
  "Garantie 1 an pièces & main d'œuvre",
  "Diagnostic gratuit",
  "Micro-soudure de précision",
  "Désoxydation ultrasons",
  "Pièces qualité certifiées",
  "Rachat de téléphone",
  "Saint-Pierre-en-Faucigny · 74",
];

export const SERVICES = [
  {
    id: "smartphones",
    title: "Smartphones",
    desc: "iPhone, Samsung, Xiaomi, Google : écran, batterie, caméra, connecteur de charge, micro et diagnostic complet.",
    tags: ["iPhone", "Samsung", "Xiaomi", "Google"],
    img: IMG.tools,
    span: "md:col-span-2 md:row-span-2",
  },
  {
    id: "tablettes",
    title: "Tablettes & iPad",
    desc: "Écran, batterie, connecteur et diagnostic selon modèle.",
    span: "md:col-span-1",
  },
  {
    id: "ordinateurs",
    title: "Ordinateurs & PC",
    desc: "Windows & Mac : migration SSD, upgrade RAM, nettoyage et refroidissement.",
    span: "md:col-span-1",
  },
  {
    id: "micro-soudure",
    title: "Micro-soudure & cartes mères",
    desc: "Reprise de composants en atelier : charge, audio, rétro-éclairage, pannes profondes.",
    img: IMG.soldering,
    span: "md:col-span-2",
  },
  {
    id: "desoxydation",
    title: "Désoxydation & données",
    desc: "Bain ultrasons, nettoyage de carte et sauvegarde de vos données quand c'est encore possible.",
    span: "md:col-span-2",
  },
];

export const SCREEN_PRICING = [
  {
    id: "premium",
    name: "Premium OLED",
    badge: "Écrans iPhone · Pièces neuves",
    desc: "Une excellente qualité d'affichage au meilleur rapport qualité / prix.",
    tagline: "Le choix idéal pour bénéficier d'une excellente qualité sans payer le prix de l'original.",
    included: [
      "Écran Premium OLED",
      "Pose professionnelle",
      "Tests complets après réparation",
      "Contrôle tactile et affichage",
      "Garantie selon conditions MAXREVIX",
    ],
    rows: [
      ["iPhone 11", "99 €"],
      ["iPhone 12 / 12 mini", "119 €"],
      ["iPhone 12 Pro / Pro Max", "129 €"],
      ["iPhone 13 / 13 mini", "129 €"],
      ["iPhone 13 Pro", "149 €"],
      ["iPhone 13 Pro Max", "159 €"],
      ["iPhone 14", "149 €"],
      ["iPhone 14 Plus", "159 €"],
      ["iPhone 14 Pro", "179 €"],
      ["iPhone 14 Pro Max", "189 €"],
      ["iPhone 15", "159 €"],
      ["iPhone 15 Plus", "169 €"],
      ["iPhone 15 Pro", "189 €"],
      ["iPhone 15 Pro Max", "199 €"],
      ["iPhone 16", "179 €"],
      ["iPhone 16 Plus", "189 €"],
      ["iPhone 16 Pro", "209 €"],
      ["iPhone 16 Pro Max", "219 €"],
      ["iPhone 17", "229 €"],
      ["iPhone 17 Pro", "259 €"],
      ["iPhone 17 Pro Max", "279 €"],
    ],
  },
  {
    id: "reconditionne",
    name: "Original Reconditionné",
    badge: "Écrans iPhone · Dalle d'origine",
    desc: "La dalle d'origine reconditionnée pour retrouver au maximum l'expérience d'origine.",
    tagline: "Le choix premium pour retrouver au plus près l'expérience d'origine.",
    included: [
      "Dalle d'origine reconditionnée",
      "Pose professionnelle",
      "Tests complets après réparation",
      "Contrôle tactile et affichage",
      "Garantie selon conditions MAXREVIX",
    ],
    rows: [
      ["iPhone 11", "149 €"],
      ["iPhone 12 / 12 mini", "169 €"],
      ["iPhone 12 Pro / Pro Max", "189 €"],
      ["iPhone 13 / 13 mini", "199 €"],
      ["iPhone 13 Pro", "249 €"],
      ["iPhone 13 Pro Max", "269 €"],
      ["iPhone 14", "249 €"],
      ["iPhone 14 Plus", "269 €"],
      ["iPhone 14 Pro", "299 €"],
      ["iPhone 14 Pro Max", "319 €"],
      ["iPhone 15", "299 €"],
      ["iPhone 15 Plus", "319 €"],
      ["iPhone 15 Pro", "339 €"],
      ["iPhone 15 Pro Max", "359 €"],
      ["iPhone 16", "299 €"],
      ["iPhone 16 Plus", "319 €"],
      ["iPhone 16 Pro", "349 €"],
      ["iPhone 16 Pro Max", "369 €"],
      ["iPhone 17", "389 €"],
      ["iPhone 17 Pro", "429 €"],
      ["iPhone 17 Pro Max", "459 €"],
    ],
  },
];

export const TOWNS = [
  "Saint-Pierre-en-Faucigny",
  "Bonneville",
  "La Roche-sur-Foron",
  "Reignier-Ésery",
  "Cluses",
  "Arenthon",
  "Amancy",
  "Saint-Laurent",
];

export const BATTERY_PRICING = [
  {
    id: "premium",
    icon: "sparkles",
    name: "Batterie Premium",
    badge: "Batteries iPhone · Pièces neuves",
    desc: "Retrouvez une autonomie optimale avec une batterie de qualité, posée et testée par nos soins.",
    tagline: "Le meilleur rapport qualité / prix.",
    rowLabel: "Modèle",
    priceLabel: "Tarif",
    rows: [
      ["iPhone 8 / SE 2020", "59 €"],
      ["iPhone X / XS / XR", "59 €"],
      ["iPhone 11", "69 €"],
      ["iPhone 12 / 12 mini", "69 €"],
      ["iPhone 12 Pro / Pro Max", "69 €"],
      ["iPhone 13 / 13 mini", "79 €"],
      ["iPhone 13 Pro / Pro Max", "79 €"],
      ["iPhone 14 / 14 Plus", "79 €"],
      ["iPhone 14 Pro / Pro Max", "79 €"],
      ["iPhone 15 / 15 Plus", "89 €"],
      ["iPhone 15 Pro / Pro Max", "89 €"],
      ["iPhone 16 / 16 Plus", "89 €"],
      ["iPhone 16 Pro / Pro Max", "99 €"],
      ["iPhone 17", "99 €"],
      ["iPhone 17 Pro / Pro Max", "109 €"],
    ],
  },
  {
    id: "oem",
    icon: "gem",
    name: "Batterie Originale / OEM",
    badge: "Batteries iPhone · D'origine / OEM",
    desc: "Pour privilégier une pièce d'origine ou de qualité constructeur lorsque disponible.",
    tagline: "Pièce originale/OEM selon disponibilité et compatibilité du modèle.",
    rowLabel: "Modèle",
    priceLabel: "Tarif",
    rows: [
      ["iPhone 8 / SE 2020", "79 €"],
      ["iPhone X / XS / XR", "79 €"],
      ["iPhone 11", "89 €"],
      ["iPhone 12 / 12 mini", "99 €"],
      ["iPhone 12 Pro / Pro Max", "99 €"],
      ["iPhone 13 / 13 mini", "109 €"],
      ["iPhone 13 Pro / Pro Max", "119 €"],
      ["iPhone 14 / 14 Plus", "119 €"],
      ["iPhone 14 Pro / Pro Max", "129 €"],
      ["iPhone 15 / 15 Plus", "129 €"],
      ["iPhone 15 Pro / Pro Max", "139 €"],
      ["iPhone 16 / 16 Plus", "139 €"],
      ["iPhone 16 Pro / Pro Max", "149 €"],
      ["iPhone 17", "159 €"],
      ["iPhone 17 Pro / Pro Max", "169 €"],
    ],
  },
];

export const SAMSUNG_PRICING = [
  {
    id: "premium-amoled",
    icon: "sparkles",
    name: "Premium AMOLED",
    badge: "Écrans Samsung · Pièces neuves",
    desc: "Le meilleur rapport qualité / prix.",
    rowLabel: "Gamme",
    priceLabel: "Tarif à partir de",
    rows: [
      ["Galaxy A14 / A15", "89 €"],
      ["Galaxy A24 / A25", "99 €"],
      ["Galaxy A34 / A35", "109 €"],
      ["Galaxy A54 / A55", "129 €"],
      ["Galaxy S20 / S21", "159 €"],
      ["Galaxy S22", "179 €"],
      ["Galaxy S23", "199 €"],
      ["Galaxy S24", "219 €"],
      ["Galaxy S25", "229 €"],
      ["Galaxy S25+", "259 €"],
      ["Galaxy S25 Ultra", "299 €"],
      ["Galaxy S26", "sur devis"],
      ["Galaxy Z Flip", "sur devis"],
      ["Galaxy Z Fold", "sur devis"],
    ],
    note: "Les tarifs Samsung varient fortement selon le modèle et selon que le constructeur fournit un module complet écran + châssis. À titre de référence, Samsung affiche actuellement 229 € pour l'écran principal du S25+ et 279 € pour celui du S25 Ultra.",
  },
  {
    id: "original-samsung",
    icon: "gem",
    name: "Original Samsung",
    badge: "Écrans Samsung · D'origine",
    desc: "Pour privilégier une pièce d'origine ou de qualité constructeur lorsque disponible.",
    rowLabel: "Gamme",
    priceLabel: "Tarif à partir de",
    rows: [
      ["Galaxy A14 / A15", "119 €"],
      ["Galaxy A24 / A25", "129 €"],
      ["Galaxy A34 / A35", "139 €"],
      ["Galaxy A54 / A55", "159 €"],
      ["Galaxy S20 / S21", "199 €"],
      ["Galaxy S22", "229 €"],
      ["Galaxy S23", "249 €"],
      ["Galaxy S24", "279 €"],
      ["Galaxy S25", "299 €"],
      ["Galaxy S25+", "329 €"],
      ["Galaxy S25 Ultra", "369 €"],
      ["Galaxy S26", "sur devis"],
      ["Galaxy Z Flip", "sur devis"],
      ["Galaxy Z Fold", "sur devis"],
    ],
  },
];

export const OTHER_REPAIRS = {
  title: "Autres réparations smartphone",
  note: "Diagnostic déduit de la réparation si celle-ci est effectuée.",
  rows: [
    ["Connecteur de charge", "59 €", "79 €"],
    ["Caméra arrière", "79 €", "109 €"],
    ["Caméra avant", "69 €", "99 €"],
    ["Haut-parleur", "59 €", "79 €"],
    ["Micro", "59 €", "79 €"],
    ["Vitre arrière", "79 €", "109 €"],
    ["Bouton / nappe", "59 €", "79 €"],
    ["Désoxydation", "à partir de 59 €", "sur devis"],
    ["Réparation logicielle", "49 €", "—"],
    ["Diagnostic", "29 €", "—"],
  ],
};

export const PC_SERVICES = {
  title: "Main-d'œuvre & services",
  note: "Ces tarifs sont cohérents avec ceux pratiqués par les ateliers français (pâte thermique, montage/clonage SSD, installation Windows…).",
  rows: [
    ["Diagnostic", "29 €"],
    ["Nettoyage interne", "49 €"],
    ["Nettoyage + pâte thermique", "69 €"],
    ["Installation SSD", "59 € + pièce"],
    ["Installation RAM", "39 € + pièce"],
    ["Clonage SSD", "69 € + pièce"],
    ["Réinstallation Windows", "69 €"],
    ["Optimisation complète", "79 €"],
    ["Suppression virus / malware", "59 €"],
    ["Optimisation PC Gaming", "89 €"],
    ["Récupération de données", "à partir de 79 €"],
    ["Diagnostic panne matérielle", "29 €"],
  ],
};

export const PC_PARTS = [
  { title: "Batterie PC portable", label: "Qualité", rows: [["Premium compatible", "dès 69 €"], ["Original constructeur / OEM", "dès 99 €"]] },
  { title: "Écran PC portable", label: "Qualité", rows: [["Premium", "dès 129 €"], ["Original / OEM", "dès 179 €"]] },
  { title: "SSD", label: "Capacité · Premium / Original", rows: [["500 Go", "99 € / 119 €"], ["1 To", "139 € / 159 €"], ["2 To", "199 € / 229 €"]] },
  { title: "RAM", label: "Capacité · Premium / Original", rows: [["8 Go", "59 € / 69 €"], ["16 Go", "79 € / 89 €"], ["32 Go", "129 € / 149 €"]] },
];

export const PC_PARTS_NOTE = "Tarifs matériel + installation. Prix définitif selon la référence et la compatibilité.";

export const ENGAGEMENT = {
  items: [
    "Diagnostic avant intervention",
    "Pièce adaptée au modèle",
    "Pose professionnelle",
    "Tests de fonctionnement",
    "Nettoyage de l'appareil",
    "Garantie selon la pièce et la réparation",
  ],
  levels: [
    { icon: "sparkles", name: "Premium", desc: "Le meilleur rapport qualité / prix." },
    { icon: "gem", name: "Original / OEM", desc: "Pour privilégier une pièce d'origine ou de qualité constructeur lorsque disponible." },
  ],
};

export const RACHAT_CATALOG = {
  note: "Estimation indicative basée sur les prix de reprise du marché (type Back Market) — offre ferme après contrôle en atelier (2 min).",
  brands: {
    Apple: [
      ["iPhone 8 / SE 2020", 40],
      ["iPhone X / XS / XR", 70],
      ["iPhone 11", 120],
      ["iPhone 12", 180],
      ["iPhone 12 Pro", 210],
      ["iPhone 13", 240],
      ["iPhone 13 Pro", 285],
      ["iPhone 14", 335],
      ["iPhone 14 Pro", 390],
      ["iPhone 14 Pro Max", 420],
      ["iPhone 15", 445],
      ["iPhone 15 Pro", 505],
      ["iPhone 15 Pro Max", 535],
      ["iPhone 16", 520],
      ["iPhone 16 Pro", 580],
      ["iPhone 16 Pro Max", 610],
      ["iPhone 17", 620],
      ["iPhone 17 Pro", 700],
      ["iPhone 17 Pro Max", 740],
    ],
    Samsung: [
      ["Galaxy A54", 80],
      ["Galaxy S22", 145],
      ["Galaxy S23", 220],
      ["Galaxy S24", 290],
      ["Galaxy S24+", 325],
      ["Galaxy S24 Ultra", 360],
      ["Galaxy S25", 330],
      ["Galaxy S25+", 370],
      ["Galaxy S25 Ultra", 420],
      ["Galaxy S26", 460],
      ["Galaxy S26 Ultra", 530],
    ],
    Google: [
      ["Pixel 7", 150],
      ["Pixel 8", 210],
    ],
    Xiaomi: [
      ["Redmi Note 12", 65],
      ["Xiaomi 13", 170],
    ],
  },
  states: [
    ["Comme neuf", 1],
    ["Bon état", 0.85],
    ["Écran cassé", 0.5],
    ["Ne s'allume plus", 0.3],
  ],
};

export const REFURBISHED = {
  chips: ["Contrôle en 25 points", "Garantie 1 an pièces & main d'œuvre", "Données précédentes effacées", "Réparé avec pièces d'origine"],
  comingTitle: "Notre boutique reconditionnée arrive bientôt",
  comingDesc: "Nous préparons une sélection d'appareils reconditionnés dans notre atelier de Saint-Pierre-en-Faucigny : chaque téléphone sera contrôlé en 25 points, remis à neuf avec pièces d'origine et garanti 1 an.",
  notifyMessage: "Je souhaite être prévenu dès l'arrivée de vos téléphones reconditionnés.",
};

export const FAQ = [
  {
    q: "Combien de temps dure une réparation ?",
    a: "La plupart des réparations courantes (écran, batterie, connecteur) sont réalisées en 30 à 60 minutes. Les pannes profondes (micro-soudure, désoxydation) peuvent demander 24 à 72 h — nous vous donnons un délai précis avant de commencer.",
  },
  {
    q: "Faut-il prendre rendez-vous ?",
    a: "Ce n'est pas obligatoire : nous vous accueillons du lundi au vendredi, de 09h00 à 19h00. Un appel ou un devis en ligne nous permet de préparer la pièce et de vous faire gagner du temps. Le diagnostic est facturé 29 € — intégralement déduit si vous faites réparer votre appareil.",
  },
  {
    q: "Que couvre la garantie ?",
    a: "Toutes nos réparations sont garanties 1 an, pièces et main d'œuvre. Si le même problème revient, nous le reprenons sans frais.",
  },
  {
    q: "Mes données sont-elles conservées ?",
    a: "Oui : sauf accord contraire, votre appareil vous est restitué avec vos données intactes. Nous vous conseillons néanmoins de faire une sauvegarde avant l'intervention.",
  },
  {
    q: "Le devis est-il payant ?",
    a: "Non. Le devis est gratuit et sans engagement. Le diagnostic est facturé 29 € mais déduit de la facture si vous faites réparer l'appareil. Le prix est confirmé avant toute intervention, sans surprise.",
  },
  {
    q: "Quels moyens de paiement acceptez-vous ?",
    a: "Espèces, carte bancaire et paiements mobiles.",
  },
  {
    q: "Réparez-vous les tablettes (iPad) et les ordinateurs ?",
    a: "Oui : iPad et tablettes Android (écran, batterie, connecteur de charge, vitre arrière) ainsi que les MacBook et PC portables toutes marques — SSD, RAM, batterie, écran, nettoyage, clavier, logiciel et récupération de données. Chaque intervention commence par un diagnostic de 29 €, déduit si vous faites réparer.",
  },
  {
    q: "Puis-je commander des accessoires en attendant l'ouverture de la boutique ?",
    a: "Oui : passez par la demande de devis en indiquant ce que vous cherchez — verre trempé, coque, chargeur, câble USB-C, support ou batterie externe — nous vous disons ce qui est disponible au meilleur prix et nous vous le réservons pour votre passage à l'atelier.",
  },
];

export const GOOGLE_REVIEW_URL = "https://g.page/r/CeKcKw54p6FzEBM/review";
export const INSTAGRAM_URL = "https://www.instagram.com/maxrevix?obrf=eGZoaG9wcG1nZ2Z2&utm_source=qr";

export const GOOGLE_RATING = { score: "5,0", count: 2 };

export const GOOGLE_REVIEWS = [
  {
    name: "Vang Vilay",
    when: "il y a 2 semaines",
    stars: 5,
    text: "Réparation sur un iPhone 17 pro Max ! Rapide et efficace, je recommande !",
  },
  {
    name: "Guillaume Noel",
    when: "il y a 3 jours",
    stars: 5,
    text: "Réparation rapide et très bonne communication Je recommande !",
  },
];
